export default {
  details: {
    init: false,
    loading: false,
    error: {},
    data: {},
  },
  organization: {
    init: false,
    loading: false,
    error: {},
    data: {},
  },
  auditLog: {
    loading: false,
    error: {},
  },
  invitations: {
    init: false,
    loading: false,
    error: {},
    data: [],
  },
  users: {
    init: false,
    loading: false,
    error: {},
    data: [],
  },
  callDialog: {
    isOpen: false,
    autoStart: false,
    contactName: '',
    contactId: 0,
  },
}
